/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDim1DiagRightIcon16Light } from './ArrowDim1DiagRightIcon16Light';
import { ArrowDim1DiagRightIcon16Regular } from './ArrowDim1DiagRightIcon16Regular';
import { ArrowDim1DiagRightIcon16Solid } from './ArrowDim1DiagRightIcon16Solid';
import { ArrowDim1DiagRightIcon20Light } from './ArrowDim1DiagRightIcon20Light';
import { ArrowDim1DiagRightIcon20Regular } from './ArrowDim1DiagRightIcon20Regular';
import { ArrowDim1DiagRightIcon20Solid } from './ArrowDim1DiagRightIcon20Solid';
import { ArrowDim1DiagRightIcon24Regular } from './ArrowDim1DiagRightIcon24Regular';
import { ArrowDim1DiagRightIcon24Solid } from './ArrowDim1DiagRightIcon24Solid';
import { ArrowDim1DiagRightIcon32Regular } from './ArrowDim1DiagRightIcon32Regular';
import { ArrowDim1DiagRightIcon64Regular } from './ArrowDim1DiagRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowDim1DiagRightIcon16Light,
        regular: ArrowDim1DiagRightIcon16Regular,
        solid: ArrowDim1DiagRightIcon16Solid,
    },
    20: {
        light: ArrowDim1DiagRightIcon20Light,
        regular: ArrowDim1DiagRightIcon20Regular,
        solid: ArrowDim1DiagRightIcon20Solid,
    },
    24: {
        regular: ArrowDim1DiagRightIcon24Regular,
        solid: ArrowDim1DiagRightIcon24Solid,
    },
    32: {
        regular: ArrowDim1DiagRightIcon32Regular,
    },
    64: {
        regular: ArrowDim1DiagRightIcon64Regular,
    },
};
export var ArrowDim1DiagRightIcon = forwardRef('ArrowDim1DiagRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
